import { ComplementsCreateSelectPage } from './../../../complements/complements-create-select/complements-create-select';
import { Component, Input } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Globals } from '../../../../globals';
import { DishServices } from '../../../dish/services';
import { AddonsTriggerVersionProPage } from '../../../addons/addons-trigger-version-pro/addons-trigger-version-pro';
import { ConfigurationServices } from '../../../configuration/services';

/**
 * Generated class for the ArticleViewVariationsFavsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-article-view-complements',
    templateUrl: 'article-view-complements.html',
})
export class ArticleViewComplementsPage {
    @Input() article: any;

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public globals: Globals,
        public dishServices: DishServices,
        public configurationServices: ConfigurationServices) {

    }

    editComplements() {
        // Reiniciar variables al entrar a los complementos
        this.configurationServices.complements_group_searchbar_text = '';
        this.configurationServices.complements_groups_selected = [];
        this.configurationServices.complements_group_array_filtered = [...this.configurationServices.complements_group_array];
        // Abrir la página de selección de complementos    
        if (this.article.type === 'dish') {
            if (this.globals.checkLimitsByLicense('dishes', 'variations_favourites')) {//version pro abierto
                this.navCtrl.push(ComplementsCreateSelectPage, {
                    update: true,
                    dish_uid: this.article.UID,
                    dish_name: this.globals.nameLangSelectDish(this.article),
                    fav_variations: this.article.variations_favourite,
                    origin: 'dish',
                    dish: this.article,
                })
            } else {
                this.navCtrl.push(AddonsTriggerVersionProPage);
            }
        } else {
            if (this.globals.checkLimitsByLicense('stock', 'variations_favourites')) {//version pro abierto
                this.navCtrl.push(ComplementsCreateSelectPage, {
                    update: true,
                    product_uid: this.article.UID,
                    product_name: this.article.name,
                    fav_variations: this.article.variations_favourite,
                    origin: 'product',
                    product: this.article
                });
            } else {
                this.navCtrl.push(AddonsTriggerVersionProPage);
            }
        }
    }

}


// WEBPACK FOOTER //
// ./src/pages/articles/articles-view/article-view-complements/article-view-complements.ts